import axios from "axios";
import {toast} from "react-hot-toast";

const devApi = "https://localhost:5006/api";
const testApi = "https://ng-test.soft-unity.com/api";
const prodApi = "https://greenside.owninn.ge/api";
export const currentApi = prodApi;


export const axiosApi = axios.create({
    baseURL: currentApi,
});

export const maintenanceMode = false;


